import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Text from '../../components/Text';
import DocumentSection from '../../components/DocumentSection';

function TermsModal({ show, setShow }) {
  const handleClose = () => setShow(false);

  return (
    <>
      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            <Text variant="documentHeaderTitle">Användarvillkor</Text>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Text variant="documentSectionText">
            För att du som användare ska kunna använda sidan på ett tryggt och
            säkert sätt, och få en optimal användarupplevelse behöver du följa
            våra användarvillkor.
          </Text>

          <DocumentSection
            title="1. Allmänt"
            texts={[
              `Användarvillkoren, tillsammans med övriga villkor som finns på
            kthbok.com (som nedan refereras som “hemsidan”) reglerar
            användningen av vår tjänst. Tjänsten tillhandahålls av Markus
            Hilding (“KTHBOK” eller “vi”). Genom att använda hemsidan och våra
            tjänster godkänner du Användarvillkoren och förbinder dig till att
            följa dem. Vi rekommenderar att du läser Användarvillkoren så att du
            och alla andra användare får en så bra användarupplevelse som
            möjligt.`,
            ]}
          />

          <DocumentSection
            title="2. Dina personuppgifter"
            texts={[
              `För att du som användare ska kunna använda vår tjänst behöver vi
            samla in och behandla vissa personuppgifter från dig. Det här görs i
            registreringsprocessen när du blir medlem och samlas endast in för
            att tjänsten ska fungera. Du kan läsa mer i vår Datapolicy om vilken
            data som samlas in, hur och varför vi gör det, samt hur du som
            användare går tillväga för att få tillgång till, eller begära att
            din data raderas.`,
            ]}
          />

          <DocumentSection
            title="3. Vem får använda tjänsten?"
            texts={[
              `För att använda vår tjänst så måste du vara 18 år gammal eller ha
              målsmans godkännande. Vi ser gärna att endast studenter använder
              tjänsten men detta är inte obligatoriskt. Tjänsten tillhandahålls
              inte till personer som tidigare har brutit mot våra användarvillkor.`,
            ]}
          />

          <DocumentSection
            title="4. Ändringar i Användarvillkoren"
            texts={[
              ` Vi kan uppdatera användarvillkoren för att återspegla förändringar i
              våra praxis eller rättsliga krav. Alla uppdateringar kommer att
              publiceras på denna sida.`,
            ]}
          />

          <DocumentSection
            title="5. Annonsering på KTHBOK"
            texts={[
              `För att annonsera på hemsidan så måste du följa våra regler för
              annonsering. Vi förbehåller oss rätten att ta bort annonser och
              användare som missbrukar, manipulerar eller använder tjänsterna på
              ett sådant sätt som bryter mot användarvillkoren och regler för
              annonsering.`,
            ]}
          />

          <DocumentSection
            title="6. Regler för annonsering"
            texts={[
              `Annonsering på hemsidan får endast ske för böcker i kategorin
            kurslitteratur och häften som är av utbildningskaraktär. Vid
            annonsering måste du ange titel och pris, vilket är obligatoriskt.
            Vidare är det rekommenderat att skriva in eventuella författare,
            ISBN-nummer och en kommentar om bokens skick för att boken lättare
            ska kunna identifieras av andra användare.`,
              `Det är ej tillåtet att annonsera och sälja vidare e-böcker som du
            har köpt.`,
              `Det är ej tillåtet att lägga upp flera annonser av samma bok om du
            inte har flera exemplar.`,
              `Du ansvarar själv som användare för din annons och att din annons
            inte bryter mot gällande lagar och regler.`,
            ]}
          />
          <DocumentSection
            title="7. Publiceringstid"
            texts={[
              `När du som användare har sålt den kurslitteratur som har annonserats
            är det ditt ansvar att ta bort din annons så fort som möjligt. Detta
            då vi vill minimera andelen inaktiva annonser på hemsidan. Vi
            förbehåller oss rätten att ta bort annonser som inte tagits bort
            eller uppdaterats på sex månader.`,
            ]}
          />
          <DocumentSection
            title="8. Kontroll av annonser"
            texts={[
              `Vi förbehåller oss rätten att granska samtliga annonser och att
            avlägsna en annons om vi anser att den bryter mot annons-villkoren.`,
            ]}
          />
          <DocumentSection
            title="9. Språk"
            texts={[`Annonsering får endast ske på svenska och engelska.`]}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Stäng
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default TermsModal;
